export enum InstallmentFrequency {
  MONTHLY = 'Mês',
  DAILY = 'Dia',
  ANNUALLY = 'Ano'
}
